/* Theme-local enhancement for Graphene search results. */
(() => {
  'use strict';
  const root = window.Shopify.routes.root.replace(/\/?$/, '/');
  const landing = document.currentScript?.dataset.combinedLanding || `${root}pages/about-us`;
  const cache = new Map();
  const processed = new WeakMap();
  const inserted = new Map();
  const variantId = (card) => /^\s*\{\s*id:\s*["']?(\d+)/.exec(card.querySelector('[variant-data]')?.textContent || '')?.[1];
  const signature = (card) => `${card.querySelector('.acs_auto_prod_name a[href]')?.href}|${variantId(card)}`;
  /** Fetch and cache a product manifest; treat unavailable responses as missing data. */
  const manifest = (handle) => {
    if (!cache.has(handle)) {
      const url = new URL(`${root}products/${handle}`, location.origin);
      url.searchParams.set('view', 'combined-search-data');
      cache.set(handle, fetch(url, { signal: AbortSignal.timeout(8000) })
        .then((response) => { if (!response.ok) throw new Error('Unavailable'); return response.json(); })
        .catch(() => null));
      if (cache.size > 80) cache.delete(cache.keys().next().value);
    }
    return cache.get(handle);
  };
  /** Reconcile set cards with current search results, removing stale cards and preserving ordinary product links. */
  const scan = () => {
    inserted.forEach((entry, source) => {
      if (!source.isConnected || signature(source) !== entry.signature || !entry.card.isConnected) {
        entry.card.remove();
        inserted.delete(source);
        processed.delete(source);
      }
    });
    document.querySelectorAll('.acs_auto_popup .acs_auto_col2 li.acs_auto_prod:not(.combined-search-set)').forEach(async (card) => {
      const current = signature(card);
      if (processed.get(card) === current) return;
      const link = card.querySelector('.acs_auto_prod_name a[href]');
      if (!link) return;
      const original = new URL(link.href, location.href);
      const match = /\/products\/([a-z0-9-]+)\/?$/.exec(original.pathname);
      if (original.origin !== location.origin || !match) return;
      processed.set(card, current);
      const data = await manifest(match[1]);
      if (!card.isConnected || signature(card) !== current || data?.handle !== match[1] || !Array.isArray(data.related) || !Array.isArray(data.variants)) return;
      const related = [...new Map(data.related.filter((item) => /^[a-z0-9-]+$/.test(item.handle) && item.handle !== data.handle && item.title).map((item) => [item.handle, item])).values()];
      if (!related.length) return;
      const variant = data.variants.find((item) => String(item.id) === variantId(card));
      // A missing print cannot safely identify the intended look on a multi-print product.
      if (data.colorIndex >= 0 && !variant) return;
      const key = `${data.handle}|${variant?.color || ''}`;
      if ([...inserted.values()].some((entry) => entry.key === key && entry.card.parentElement === card.parentElement)) return;
      const destination = new URL(landing, location.origin);
      destination.searchParams.set('view', 'combined-search-results');
      destination.searchParams.set('source', data.handle);
      if (variant?.color) destination.searchParams.set('print', variant.color);
      const names = [data.title, ...related.map((item) => item.title)];
      const title = `${names.slice(0, -1).join(', ')} & ${names.at(-1)} Set`;
      const images = Array.isArray(data.images) ? data.images : [];
      const matchingImages = images.filter((image) => variant?.colorHandle && image.color?.includes(variant.colorHandle));
      const singlePrint = new Set(data.variants.map((item) => item.color)).size <= 1;
      const printImages = matchingImages.length ? matchingImages : singlePrint ? images : [];
      const imageSources = [...new Set([printImages[2]?.src, data.setImage, printImages.at(-1)?.src,
        variant?.image, card.querySelector('.acs_auto_prod_image img')?.getAttribute('src')].filter(Boolean))];
      // Build a distinct set result, without copying the source product's quickview or tracking data.
      const combined = document.createElement('li');
      combined.className = 'acs_auto_prod combined-search-set';
      const imageContainer = document.createElement('div');
      imageContainer.className = 'acs_auto_prod_image';
      const imageLink = document.createElement('a');
      imageLink.href = destination.href;
      imageLink.setAttribute('aria-label', title);
      const image = document.createElement('img');
      image.alt = title;
      image.loading = 'lazy';
      if (imageSources.length) image.src = imageSources.shift();
      image.addEventListener('error', () => {
        if (imageSources.length) image.src = imageSources.shift();
      });
      imageLink.append(image);
      imageContainer.append(imageLink);
      const name = document.createElement('div');
      name.className = 'acs_auto_prod_name';
      const titleLink = document.createElement('a');
      titleLink.href = destination.href;
      titleLink.textContent = title;
      name.append(titleLink);
      const caption = document.createElement('div');
      caption.className = 'combined-search-set__caption';
      caption.textContent = `${names.length} pieces, sold separately`;
      combined.append(imageContainer, name, caption);
      inserted.set(card, { card: combined, signature: current, key });
      card.after(combined);
    });
  };
  /** Observe the Graphene popup and enrich its initial and subsequent results. */
  const init = () => {
    const popup = document.querySelector('.acs_auto_popup');
    if (!popup) return;
    new MutationObserver(scan).observe(popup, { childList: true, subtree: true, characterData: true });
    scan();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
